export default __webpack_public_path__ + "static/media/ntuc-health-logo-white-hd.7750009b.png";